// extracted by css-extract-rspack-plugin
export default {"ListItemMetadata_0":"IssueItemMetadata-module__ListItemMetadata_0__SwUc_Ip"};